module.exports = __webpack_public_path__ + "img/logo-lyon-metropole-habitat.d1326a9a.jpg";